import type { ClientConfig } from '~ng-common-lib/client-config';
import { DEFAULT_CLIENT_CONFIG } from '~ng-common-lib/client-config';

export const CLIENT_CONFIG_GENERATED: ClientConfig = DEFAULT_CLIENT_CONFIG;
